import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import { Webform, Profile } from '@uncinc/react-drupal-core';

import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { ParagraphWebform as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphWebformProps {
  entity: ImmutableEntity<Type>;
}

const ParagraphWebform: React.FC<ParagraphWebformProps> = ({ entity }) => {
  const paragraphWebform = entity.toJS();
  const title = paragraphWebform.field_title[0]?.value;
  const body = paragraphWebform.field_body[0]?.processed;
  const persons = paragraphWebform.field_persons;
  const { status, target_id: id } = paragraphWebform.field_webform[0];

  const hasSidebar = body || persons.length > 0;

  const classes = c('Paragraph', 'ParagraphWebform');

  const titleColClasses = c('col-12 col-md-10 offset-md-1', {
    'col-lg-4 offset-lg-0': hasSidebar,
    'col-lg-8 offset-lg-2': !hasSidebar,
  });

  const webformColClasses = c('col-12 col-md-10 offset-md-1', {
    'col-lg-7 offset-lg-1': hasSidebar,
    'col-lg-8 offset-lg-2': !hasSidebar,
  });

  return (
    <div className={classes}>
      <Container>
        {title && (
          <div className="row">
            <div className={titleColClasses}>
              <h2 className="ParagraphWebform__title">
                {title}
              </h2>
            </div>
          </div>
        )}

        <div className="row">
          {hasSidebar && (
            <div className="col-12 col-md-10 offset-md-1 col-lg-4 offset-lg-0">
              {body && (
                <WysiwygField
                  className="ParagraphWebform__body text--large"
                  html={body}
                />
              )}

              {persons.length > 0 && (
                <ul className="ParagraphWebform__persons">
                  {persons.map((person) => (
                    <li key={`person:${person.target_id}`}>
                      <Profile
                        entity={Immutable.fromJS(person.entity)}
                        viewMode="teaser_small"
                      />
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}

          <div className={webformColClasses}>
            <div className="ParagraphWebform__webform">
              <Webform
                id={id}
                status={status}
                scrollToTopAfterSubmit={false}
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphWebform;
